// extracted by mini-css-extract-plugin
export default {"zoomModal":"v1-z","image":"w1-z","button":"x1-z","isOverlayShown":"y1-z"};